// extracted by mini-css-extract-plugin
export var logo = "navbar-module--logo--f1d42";
export var navbar = "navbar-module--navbar--2c8f7";